import { render } from "./UpdateRolePage.vue?vue&type=template&id=75e752f8&ts=true"
import script from "./UpdateRolePage.vue?vue&type=script&lang=ts"
export * from "./UpdateRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__